export const firebaseConfig = {
  apiKey: 'AIzaSyBkiV8qWcitk7gvUMQ9CAwIsBP_sbrAvk4',
  authDomain: 'auth.dev.handle.com',
  projectId: 'handle-dev-8402b',
  storageBucket: 'handle-dev-8402b.appspot.com',
  messagingSenderId: '632561579146',
  appId: '1:632561579146:web:c1fb26facee45a9eed6973',
};
